import React, { useCallback } from 'react';

import { NavLink } from 'react-router-dom';

import './link.css';

export default function Link({ to, ...restProps }) {
    const checkActive = useCallback((_, location) => `${location.pathname}${location.search}`.includes(to?.split('/all')[0]), [to]);

    return (
        <NavLink
            className="c-nav-link"
            activeClassName="c-nav-link_active"
            isActive={checkActive}
            to={to}
            {...restProps}
        />
    );
}
